/**
 *  @class
 *  @function DigitalClock
 */
if (!customElements.get('digital-clock')) {
  class DigitalClock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setInterval(this.getCurrentTime.bind(this), 1000);
    }
    getCurrentTime() {
      this.date = new Date();
      let time = new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Los_Angeles',
        timeZoneName: 'short'
      }).format(this.date);
      this.textContent = time;
    }
  }
  customElements.define('digital-clock', DigitalClock);
}